export default __webpack_public_path__ + "static/media/logoPDF.6c09f088.png";